import { BaseUrl } from "@/config";
import { createCollectibleLink, createMarketplaceItemLink } from "@/router";
import { fetchCategoryById } from "@/services/collection/categories";
import { isCreatedFromCollectible, type MarketplaceItem } from "@/services/marketplace/item";
import { computedAsync } from "@vueuse/core";
import type { Ref } from "vue";
import { readonly } from "vue";
import { useRouter } from "vue-router";

export function useMarketplaceItemMeta(item: Ref<MarketplaceItem | undefined>) {
  const router = useRouter();

  const canonical = computedAsync(async () => {
    const i = item.value;

    if (i === undefined) {
      return undefined;
    } else if (isCreatedFromCollectible(i)) {
      const category = await fetchCategoryById(i.categoryId);
      const collectibleId = i.collectible.id;
      const link = createCollectibleLink(category, collectibleId);
      const url = BaseUrl + router.resolve(link).href;
      return url;
    } else {
      const link = createMarketplaceItemLink(i.id, i.name);
      const url = BaseUrl + router.resolve(link).href;
      return url;
    }
  });

  return {
    canonical: readonly(canonical),
  };
}
